export const fromSignUpFinalizationPage = 'fsf'
